import axios from "axios";

export const state = {
    schoolhouses: [],
};

export const getters = {
    schoolhouses: state => state.schoolhouses,
};

export const mutations = {
    setHouse(state, newValue) {
        state.schoolhouses = newValue
    },
};

export const actions = {
    fetchSchoolHouses({ commit }) {
        axios.get('/schoolhouses').then(res => {
            commit('setHouse', res.data.schoolhouses);
        })
    },
};
